module.exports = __webpack_public_path__ + "static/media/mobile-phone-icon-blue.32a49919.svg";